export const getMovedOverviewPlaces = (movedPlace) => {
  const placesById = new Map();
  const visit = (place) => {
    if (!place?.idEntity || placesById.has(place.idEntity)) return;
    placesById.set(place.idEntity, place);
    if (Array.isArray(place.composedOfChildren)) place.composedOfChildren.forEach(visit);
  };
  visit(movedPlace);
  return [...placesById.values()];
};

// Save immutable edit snapshots in order. A slow earlier save must never overwrite
// a later drag or Undo, and a response must never replace the active editor draft.
export const createOverviewGeometrySaver = ({ select, update, toEditable, normalize, validate }) => {
  let pending = Promise.resolve();
  const saveGeometry = (place) => new Promise((resolve, reject) => {
    select(place.idEntity, (loadErr, loaded) => {
      if (loadErr || !loaded || loaded.error) {
        reject({ err: loadErr, response: loaded });
        return;
      }
      let payload;
      let validationMessage;
      try {
        payload = normalize({ ...toEditable(loaded), location: place.location, shape: place.shape });
        validationMessage = validate(payload);
      } catch (err) {
        reject({ err, response: null });
        return;
      }
      if (validationMessage) {
        reject({ err: validationMessage, response: null });
        return;
      }
      update(payload, (err, response) => {
        if (err || response?.error) reject({ err, response });
        else resolve(response);
      });
    });
  });
  return (movedPlace) => {
    const places = getMovedOverviewPlaces(movedPlace);
    const saved = pending.then(async () => {
      const results = await Promise.allSettled(places.map(saveGeometry));
      const failed = results.find(result => result.status === 'rejected');
      if (failed) throw failed.reason;
      return results.map(result => result.value);
    });
    pending = saved.catch(() => {});
    return saved;
  };
};
